import { Box, Typography } from "@mui/material";

import AppButton from "@/common/components/Button/AppButton";
import { GeneralQueryParams } from "@/common/ts/GeneralQueryParams";

export interface NoInternetErrorPageQueryParams extends GeneralQueryParams {
  returnPath?: string | null;
}

/** If dynamic import failed, treat it as app update. */
export function DynamicImportErrorFallback() {
  return (
    <Box sx={{ p: 2, textAlign: "center" }}>
      <Typography variant='h4'>The app has been updated. Please refresh the page.</Typography>
      <Typography variant='body2'>
        This is required to continue using the app. We apologize for the inconvenience.
      </Typography>
      <Box>
        <AppButton
          sx={{ mt: 1 }}
          variant='contained'
          color='primary'
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </AppButton>
      </Box>
    </Box>
  );
}
